module.exports = __webpack_public_path__ + "img/508.c06dc324.png";